<template>
  <b-container class="admin-mission-view-container">
    <MissionStatement
      v-if="stateShowed"
      :hideStatement="hideStatement"
      :missionFocus="missionFocus"
    />
    <h1>任務單紀錄</h1>
    <b-button-group>
      <b-button
        :variant="showAllMission ? 'primary' : null"
        @click="switchShowMode(true)"
      >全部任務</b-button>
      <b-button
        :variant="!showAllMission ? 'primary' : null"
        @click="switchShowMode(false)"
      >待審核與退回任務</b-button>
    </b-button-group>
    <MissionTable
      v-if="missions.length"
      :items="systemMission"
      :productMethod="showStatement"
      :showAllMission="showAllMission"
    />
    <section v-else>
      <b-spinner label="Spinning"></b-spinner>
    </section>
  </b-container>
</template>
<script>
  import { mapState, mapActions } from "vuex";
  import MissionStatement from "@/components/MissionStatement";
  import MissionTable from "@/components/MissionTable";

  export default {
    data() {
      return {
        missionStatement: {},
        missiontype: "",
        missionState: "",
        missionId: "",
        missionFocus: null,
        stateShowed: false,
        showAllMission: true,
      };
    },
    computed: {
      ...mapState("backend", ["Authority", "missions"]),
      systemMission: function () {
        return this.missions
          .filter((doc) => ["pending", "turnback"].includes(doc.state) || this.showAllMission)
          .map((doc) => {
            const missionTitle = doc.system === "News" ? doc.Statement.news_CH : doc.Statement.name_CH;
            return { ...doc, missionTitle };
          });
      },
    },
    methods: {
      ...mapActions("backend", ["deleteMission"]),

      showStatement: function (mission) {
        this.missionStatement = mission.Statement;
        this.missiontype = mission.type;
        this.missionState = mission.state;
        this.missionId = mission.id;
        this.stateShowed = true;
        this.missionFocus = mission;
      },
      hideStatement: function () {
        this.stateShowed = false;
      },
      switchShowMode: function (mode) {
        this.showAllMission = mode;
      },
    },
    components: {
      MissionStatement,
      MissionTable,
    },
  };
</script>
